import { formatKoreanUnit, calcDeltaPercent, formatDelta } from "Components/Sales/salesFormat";

const styles = {
  grid: {
    display: "grid",
    gridTemplateColumns: "repeat(auto-fit, minmax(200px, 1fr))",
    gap: "14px",
    marginBottom: "20px",
  },
  card: {
    backgroundColor: "#ffffff",
    border: "1px solid #e5e7eb",
    borderRadius: "12px",
    padding: "18px 20px",
  },
  label: { fontSize: "13px", color: "#6b7280", marginBottom: "6px" },
  value: { fontSize: "24px", fontWeight: "700", color: "#1f2937", lineHeight: 1.15 },
  valueNet: { color: "#059669" },
  sub: { fontSize: "12px", color: "#6b7280", marginTop: "6px" },
  none: { fontSize: "16px", fontWeight: "500", color: "#9ca3af" },
  delta: {
    display: "inline-flex",
    alignItems: "center",
    padding: "2px 8px",
    borderRadius: "999px",
    fontSize: "13px",
    fontWeight: "600",
  },
  deltaUp: { color: "#166534", backgroundColor: "#d1fae5" },
  deltaDown: { color: "#991b1b", backgroundColor: "#fee2e2" },
};

const DeltaCard = ({ label, compareYear, current, base, throughMonth }) => {
  if (!compareYear || base === null || base === undefined) {
    return (
      <div style={styles.card}>
        <div style={styles.label}>동기 대비 {label}</div>
        <div style={styles.none}>비교 대상 없음</div>
        <div style={styles.sub}>비교 대상을 고르면 증감률이 표시됩니다</div>
      </div>
    );
  }
  const pct = calcDeltaPercent(current, base);
  const up = pct === null || pct >= 0;
  return (
    <div style={styles.card}>
      <div style={styles.label}>{compareYear}년 동기 대비 {label}</div>
      <div style={styles.value}>
        <span style={{ ...styles.delta, ...(up ? styles.deltaUp : styles.deltaDown) }}>{formatDelta(pct)}</span>
      </div>
      <div style={styles.sub}>
        1~{throughMonth}월 기준 {formatKoreanUnit(current)} vs {compareYear}년 {formatKoreanUnit(base)}
      </div>
    </div>
  );
};

const SalesTrendCards = ({ year, compareYear, ytd, totalCount }) => {
  const gross = ytd?.gross ?? 0;
  const net = ytd?.net ?? 0;
  const netRate = gross ? ((net / gross) * 100).toFixed(1) : "0.0";
  const throughMonth = ytd?.through_month ?? 12;

  return (
    <div style={styles.grid}>
      <div style={styles.card}>
        <div style={styles.label}>{year}년 누적 매출</div>
        <div style={styles.value}>{formatKoreanUnit(gross)} 원</div>
        <div style={styles.sub}>1~{throughMonth}월 · {(totalCount ?? 0).toLocaleString("ko-KR")}건</div>
      </div>
      <div style={styles.card}>
        <div style={styles.label}>{year}년 누적 순매출</div>
        <div style={{ ...styles.value, ...styles.valueNet }}>{formatKoreanUnit(net)} 원</div>
        <div style={styles.sub}>순매출률 {netRate}%</div>
      </div>
      <DeltaCard label="매출" compareYear={compareYear} current={gross} base={ytd?.compare_gross} throughMonth={throughMonth} />
      <DeltaCard label="순매출" compareYear={compareYear} current={net} base={ytd?.compare_net} throughMonth={throughMonth} />
    </div>
  );
};

export default SalesTrendCards;
